import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVisibilityComponent } from "./med-icon-visibility.component";

@NgModule({
  declarations: [
    MedIconVisibilityComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconVisibilityComponent,
  ],
})
export class MedIconVisibilityModule { }
